import React, { useState } from 'react';
import {
  OpenCloseContainer,
  PanelContainer,
  PanelMainContainer,
} from './DefaultPanel.styled';
// @ts-ignore
import {Icons} from '@sede-enterprise/shell-ds-react-framework'
interface IDefaultPanelProps {
  panel?: React.ReactNode;
}

export const DefaultPanel: React.FC<IDefaultPanelProps> = (props) => {
  const [showPanelMax, setShowPanelMax] = useState(false);
  return (
    <div data-testid='DefaultPanel'>
      {props.panel && (
        <PanelContainer open={showPanelMax}>
          <OpenCloseContainer>
            {
              showPanelMax ? <Icons.ChevronLeft onClick={()=>{setShowPanelMax(!showPanelMax)}} /> : 
              <Icons.ChevronRight onClick={()=>{setShowPanelMax(!showPanelMax)}} /> 
            }
          </OpenCloseContainer>
          <PanelMainContainer open={showPanelMax}>{props.panel}</PanelMainContainer>
        </PanelContainer>
      )}
    </div>
  );
};

export default DefaultPanel;
